(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspots-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hotspot-accordion')) {
    customElements.define('hotspot-accordion', class extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this)
        this.addEventListener('click', this.handleClick)
        customElements.whenDefined('collapsible-tab').then(() => this.init())
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick)
      }

      init() {
        this.hotspots = [...this.querySelectorAll('[data-hotspot-index]')]
        this.tabs = [...this.querySelectorAll('collapsible-tab')]
        const selected = this.tabs.findIndex((tab) => tab.selected)
        this.activate(selected < 0 ? 0 : selected)
      }

      handleClick(event) {
        const hotspot = event.target.closest('[data-hotspot-index]')
        if (hotspot && this.contains(hotspot)) {
          this.select(Number(hotspot.dataset.hotspotIndex))
          return
        }

        const trigger = event.target.closest('collapsible-tab [data-trigger]')
        if (!trigger || !this.contains(trigger)) return
        const tab = trigger.closest('collapsible-tab')
        requestAnimationFrame(() => this.activate(tab.selected ? this.tabs.indexOf(tab) : -1))
      }

      select(index) {
        this.tabs.forEach((tab, tabIndex) => {
          if (tabIndex === index && !tab.selected) tab.open()
          if (tabIndex !== index && tab.selected) tab.close()
        })
        this.activate(index)
      }

      activate(index) {
        this.hotspots.forEach((hotspot, hotspotIndex) => {
          const active = hotspotIndex === index
          hotspot.classList.toggle('is-active', active)
          hotspot.setAttribute('aria-pressed', String(active))
        })
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
